import { filesManager } from '../../../actionTypes/entities';
import uploadFileRequestReducerFactory from '../../../reducerFactories/uploadFileRequestReducerFactory';

const fileReducer = uploadFileRequestReducerFactory(filesManager.types);

export default fileReducer;
